import { mapGetters } from 'vuex'
import types from '../../store/globaltypes'
import { isIOSApp } from '../../helpers/platform'

export default {
  name: 'bottomnav',
  components: {},
  props: [],
  data () {
    return {
      isIOS: isIOSApp(),
      links: []
    }
  },
  computed: {
    ...mapGetters({
      user: types.user.getters.currentUser,
      productCounter: types.shoppingcart.getters.productCounter
    }),
    notificationBadge () {
      return this.unreadNotifications.length
    }
  },
  mounted () {
    this.links = this.$router.options.routes
  },
  methods: {
  },
  watch: {
  }
}
